// src/config/ecuador.js
// Provincias y ciudades principales de Ecuador

export const ECUADOR = [
  {
    provincia: "Azuay",
    cod_dane: "0101000",
    ciudades: [
      "Cuenca",
      "Gualaceo",
      "Paute",
      "Sígsig",
      "Santa Isabel",
      "Chordeleg",
      "Girón",
      "Nabón",
      "Oña",
      "Pucará",
      "San Fernando",
      "Sevilla de Oro",
    ],
  },
  {
    provincia: "Bolívar",
    cod_dane: "0201000",
    ciudades: [
      "Guaranda",
      "Chillanes",
      "Chimbo",
      "Echeandía",
      "Las Naves",
      "San Miguel",
    ],
  },
  {
    provincia: "Cañar",
    cod_dane: "0301000",
    ciudades: [
      "Azogues",
      "Biblián",
      "Cañar",
      "Déleg",
      "El Tambo",
      "La Troncal",
      "Suscal",
    ],
  },
  {
    provincia: "Carchi",
    cod_dane: "0401000",
    ciudades: [
      "Tulcán",
      "Bolívar",
      "Espejo",
      "Mira",
      "Montúfar",
      "San Pedro de Huaca",
    ],
  },
  {
    provincia: "Chimborazo",
    cod_dane: "0601000",
    ciudades: [
      "Riobamba",
      "Alausí",
      "Colta",
      "Chambo",
      "Chunchi",
      "Guamote",
      "Guano",
      "Pallatanga",
      "Penipe",
      "Cumandá",
    ],
  },
  {
    provincia: "Cotopaxi",
    cod_dane: "0501000",
    ciudades: [
      "Latacunga",
      "La Maná",
      "Pangua",
      "Pujilí",
      "Salcedo",
      "Saquisilí",
      "Sigchos",
    ],
  },
  {
    provincia: "El Oro",
    cod_dane: "0701000",
    ciudades: [
      "Machala",
      "Arenillas",
      "Atahualpa",
      "Balsas",
      "Chilla",
      "El Guabo",
      "Huaquillas",
      "Las Lajas",
      "Marcabelí",
      "Pasaje",
      "Piñas",
      "Portovelo",
      "Santa Rosa",
      "Zaruma",
    ],
  },
  {
    provincia: "Esmeraldas",
    cod_dane: "0801000",
    ciudades: [
      "Esmeraldas",
      "Atacames",
      "Eloy Alfaro",
      "Muisne",
      "Quinindé",
      "Río Verde",
      "San Lorenzo",
    ],
  },
  {
    provincia: "Galápagos",
    cod_dane: "2001000",
    ciudades: ["Puerto Baquerizo Moreno", "Puerto Ayora", "Puerto Villamil"],
  },
  {
    provincia: "Guayas",
    cod_dane: "0901000",
    ciudades: [
      "Guayaquil",
      "Alfredo Baquerizo Moreno",
      "Balao",
      "Balzar",
      "Colimes",
      "Coronel Marcelino Maridueña",
      "Daule",
      "Durán",
      "El Empalme",
      "El Triunfo",
      "General Antonio Elizalde",
      "Isidro Ayora",
      "Lomas de Sargentillo",
      "Milagro",
      "Naranjal",
      "Naranjito",
      "Nobol",
      "Palestina",
      "Pedro Carbo",
      "Playas",
      "Salitre",
      "Samborondón",
      "Santa Lucía",
      "Simón Bolívar",
      "Yaguachi",
    ],
  },
  {
    provincia: "Imbabura",
    cod_dane: "1001000",
    ciudades: [
      "Ibarra",
      "Antonio Ante",
      "Cotacachi",
      "Otavalo",
      "Pimampiro",
      "San Miguel de Urcuquí",
    ],
  },
  {
    provincia: "Loja",
    cod_dane: "1101000",
    ciudades: [
      "Loja",
      "Calvas",
      "Catamayo",
      "Célica",
      "Chaguarpamba",
      "Espíndola",
      "Gonzanamá",
      "Macará",
      "Olmedo",
      "Paltas",
      "Pindal",
      "Quilanga",
      "Saraguro",
      "Sozoranga",
      "Zapotillo",
    ],
  },
  {
    provincia: "Los Ríos",
    cod_dane: "1201000",
    ciudades: [
      "Babahoyo",
      "Baba",
      "Buena Fé",
      "Mocache",
      "Montalvo",
      "Palenque",
      "Puebloviejo",
      "Quevedo",
      "Quinsaloma",
      "Urdaneta",
      "Valencia",
      "Ventanas",
      "Vinces",
    ],
  },
  {
    provincia: "Manabí",
    cod_dane: "1301000",
    ciudades: [
      "Portoviejo",
      "24 de Mayo",
      "Bolívar",
      "Chone",
      "El Carmen",
      "Flavio Alfaro",
      "Jama",
      "Jaramijó",
      "Jipijapa",
      "Junín",
      "Manta",
      "Montecristi",
      "Olmedo",
      "Paján",
      "Pedernales",
      "Pichincha",
      "Puerto López",
      "Rocafuerte",
      "San Vicente",
      "Santa Ana",
      "Sucre",
      "Tosagua",
    ],
  },
  {
    provincia: "Morona Santiago",
    cod_dane: "1401000",
    ciudades: [
      "Macas",
      "Gualaquiza",
      "Huamboya",
      "Limón Indanza",
      "Logroño",
      "Pablo Sexto",
      "Palora",
      "San Juan Bosco",
      "Santiago",
      "Sucúa",
      "Taisha",
      "Tiwintza",
    ],
  },
  {
    provincia: "Napo",
    cod_dane: "1501000",
    ciudades: [
      "Tena",
      "Archidona",
      "Carlos Julio Arosemena Tola",
      "El Chaco",
      "Quijos",
    ],
  },
  {
    provincia: "Orellana",
    cod_dane: "2200000",
    ciudades: [
      "Puerto Francisco de Orellana",
      "Aguarico",
      "La Joya de los Sachas",
      "Loreto",
    ],
  },
  {
    provincia: "Pastaza",
    cod_dane: "1601000",
    ciudades: ["Puyo", "Arajuno", "Mera", "Santa Clara"],
  },
  {
    provincia: "Pichincha",
    cod_dane: "1701000",
    ciudades: [
      "Quito",
      "Cayambe",
      "Mejía",
      "Pedro Moncayo",
      "Pedro Vicente Maldonado",
      "Puerto Quito",
      "Rumiñahui",
      "San Miguel de los Bancos",
    ],
  },
  {
    provincia: "Santa Elena",
    cod_dane: "2401000",
    ciudades: ["Santa Elena", "La Libertad", "Salinas"],
  },
  {
    provincia: "Santo Domingo de los Tsáchilas",
    cod_dane: "2301000",
    ciudades: ["Santo Domingo", "La Concordia"],
  },
  {
    provincia: "Sucumbíos",
    cod_dane: "2101000",
    ciudades: [
      "Nueva Loja (Lago Agrio)",
      "Cascales",
      "Cuyabeno",
      "Gonzalo Pizarro",
      "Putumayo",
      "Shushufindi",
      "Sucumbíos",
    ],
  },
  {
    provincia: "Tungurahua",
    cod_dane: "1801000",
    ciudades: [
      "Ambato",
      "Baños de Agua Santa",
      "Cevallos",
      "Mocha",
      "Patate",
      "Quero",
      "San Pedro de Pelileo",
      "Santiago de Píllaro",
      "Tisaleo",
    ],
  },
  {
    provincia: "Zamora Chinchipe",
    cod_dane: "1901000",
    ciudades: [
      "Zamora",
      "Centinela del Cóndor",
      "Chinchipe",
      "El Pangui",
      "Nangaritza",
      "Palanda",
      "Paquisha",
      "Yacuambi",
      "Yantzaza",
    ],
  },
];
